export default __webpack_public_path__ + "static/included-3-c43933be11e83a83f11fe345af52525a.png";